// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__YAagA","info":"UpdateTermsInfo_info__39_1m"};